import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { valueForKeyPath as v } from '../../../../utils.jsx';

import MediaBrowserService from '../mediaBrowser/MediaBrowserService.jsx';

var VideoWidget = createReactClass({
  propTypes: {
    index: PropTypes.number,
    uri: PropTypes.string,
    uuid: PropTypes.string,
    changeObject: PropTypes.func,
    contentSpace: PropTypes.string,
  },

  getDefaultProps() {
    return {
      index: 0,
      uri: '',
      uuid: '',
      changeObject: function() {},
      baseUri: '/userdata/',
    };
  },

  setVideo(event) {
    var _this = this;
    var onFileSelect = function(uri) {
      MediaBrowserService.closeMediaBrowser();
      var object = _this.getWidgetObject();
      object.uri = uri;
      _this.props.changeObject(_this.props.index, object);
    };
    MediaBrowserService.openMediaBrowser(
      onFileSelect,
      null,
      this.props.mediaManager,
      false,
    );
  },

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  },

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  },

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  },

  getWidgetObject() {
    return { type: 'video', uri: this.props.data.uri,source: this.props.data.source, description: this.props.data.description, uuid: this.props.uuid };
  },

  onChange(e) {
    const widget  = {
      ...this.getWidgetObject(),
      [e.target.name]: e.target.value,
    };


    this.props.changeObject(
      this.props.index,
      widget
    )          
  },

  render() {
    var contentHtml = null;        
    if (!this.props.data.uri) {
      // ak nemame uri tak zobrazime plochu pre pridanie
      contentHtml = (
        <div
          onClick={this.setVideo}
          className="add-image"
          style={{ width: '640px', margin: '0 auto' }}
        >
          <i className="fa fa-video-camera" />
        </div>
      );
    } else {
      // ak mame zadane uri tak zobrazime obrazok
      contentHtml = (
        <div>
          <video
            style={{
              width: '640px',
              height: '320px',
              margin: '0 auto',
              display: 'block',
              background: 'black',
            }}
            controls="controls"
          >
            <source
              src={`https://data.tvkosice.sk/cmdata/${this.props.data.uri}`}
              type="video/mp4"
            />
          </video>
          <br />
          <p style={{ textAlign: 'center' }}>
            <button onClick={this.setVideo} style={{ margin: '0 auto' }}>
              <i className="fa fa-video-camera" /> zmeniť
            </button>
          </p>
          <div className="form-group">
            <input
              placeholder="Popis videa"
              type="text"
              className="form-control"
              value={v(this.props.data, 'description', '')}
              name="description"
              onChange={this.onChange}
            />
          </div>
          <div className="form-group">
            <input
              placeholder="Zdroj videa"
              type="text"
              className="form-control"
              value={v(this.props.data, 'source', '')}
              name="source"
              onChange={this.onChange}
            />
          </div>
        </div>
      );
    }
    return (
      <div
        data-index={this.props.index}
        style={{ clear: 'both' }}
        className="panel panel-default widget-body"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong> {this.props.name}</strong>
          </span>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body">
          <div className="alert alert-danger">
            Podporovaný video formát je <strong>MP4</strong>
          </div>
          {contentHtml}
        </div>
      </div>
    );
  },
});

export default VideoWidget;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleVideoWidget.jsx